import { forwardRef } from 'react';
import styled from 'styled-components';
import {
  type CounterProps,
  Counter as LibCounter,
  type TimerAPI
} from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { ElementBase } from '../element-base';
import type { TimerProps } from './types';
import { useNumberCounter } from './utils';

export const NumberCounter = forwardRef<TimerAPI, TimerProps>(
  ({ style, className, onCountdownFinish, onCountdownReset }, ref) => {
    const { timerStartNumber, timerEndNumber } = useSettings();
    const value = useNumberCounter({
      ref,
      onCountdownFinish,
      onCountdownReset
    });
    const maxLength = Math.max(timerStartNumber, timerEndNumber).toString()
      .length;

    return (
      <Container style={style} className={className}>
        <Counter maxLength={maxLength}>{value}</Counter>
      </Container>
    );
  }
);

const Container = styled(ElementBase)`
  display: flex;
  flex-direction: column;
  align-items: inherit;
  justify-content: inherit;
  gap: 0.125em;
  min-width: 1.875em;
  font-size: ${({
    theme: {
      timer: { size }
    }
  }) => size}px;
`;

const Counter = styled(LibCounter).attrs(
  ({
    theme: {
      timer: { timerColor, timerBackgroundColor, animation, timerStyle }
    }
  }) => ({
    animation,
    counterStyle: timerStyle,
    color: timerColor,
    backgroundColor: timerBackgroundColor,
    className: createReadableClass({ component: 'element-counter' })
  })
)<Partial<CounterProps>>``;
